import React, { Component } from "react"
import { Table } from "antd"
import { observer, inject } from "mobx-react"
import { withRouter } from 'react-router-dom'

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.columns = []
  }

  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  renderDataFormat = (record, type) => {
    if (record.data && record.data[type]) {
      const dataCount = record.data[type].dataCount
      const reportCount = record.data[type].reportCount
      const size = record.data[type].size.toFixed(2)
      const downFlow = record.data[type].downFlow.toFixed(2)
      return (
        <div>
          {dataCount + '条 / ' + size + 'GB / ' + downFlow + 'GB/ ' + reportCount + '份'}
        </div>
      )
    } else {
      return '-'
    }
  }

  render() {
    let {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        },
      }
    } = this.props

    const columns = [
      {
        title: (
          <div className="ta-l">账户</div>
        ),
        width: "20%",
        dataIndex: "username",
        render: (text) => {
          return (
            (<div>{text}</div>)
          )
        }
      }, {
        title: (
          <div className="ta-l">机构名称</div>
        ),
        width: "20%",
        dataIndex: "orgName",
        render: (text) => {
          return (
            (<div>{text}</div>)
          )
        }
      }, {
        title: (
          <div className="ta-l">PGS(数据 / 存储 / 下载 / 报告)</div>
        ),
        dataIndex: "pgs",
        width: "15%",
        render: (text, record) => {
          return this.renderDataFormat(record, 'pgs')
        }
      }, {
        title: (
          <div className="ta-l">PGD(数据 / 存储 / 下载 / 报告)</div>
        ),
        width: "15%",
        dataIndex: "pgd",
        render: (text, record) => {
          return this.renderDataFormat(record, 'pgd')
        }
      }, {
        title: <div className="ta-l">AZF(数据 / 存储 / 下载 / 报告)</div>,
        dataIndex: "azf",
        width: "15%",
        render: (text, record) => {
          return this.renderDataFormat(record, 'azf')
        }
      },{
        title: <div className="ta-l">array-pgt(数据 / 存储 / 下载 / 报告)</div>,
        dataIndex: "array-pgt",
        width: "15%",
        render: (text, record) => {
          return this.renderDataFormat(record, 'array-pgt')
        }
      }
    ]

    return (
      <div>
        <div className="wrapper-box">
          <Table
            columns={columns}
            className="datamanage-table"
            rowKey={record => record.userId + "store"}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(Index)



// WEBPACK FOOTER //
// ./src/app/pages/preview/data_statistics/containers/DataTable.js